import { Directive, Input, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

const INFO_HELP: Map<string, string> = new Map(
  [
    //ON - Online Account
    //A - Application Form
    //OW - Owners
    //W - W\G\S\C
    //D - Dealerships
    //C - Contracts
    
    //.1 - Section (separated by Line)
    //.a - Field
    ["ON.1.a", "Enter your First Name"],
    ["ON.1.b", "Enter your Last Name"],
    ["ON.1.c", "Enter your Email Address"],
    ["ON.1.d", "Enter a strong password using letters, uppercase letters, numbers and symbols"],
    ["A.1.a", "Date Application was submitted. Automatically assigned by system."],
    ["A.1.b", "Online Profile Email Account."],
    ["A.1.c", "Unique application id. Automatically generated and assigned when application is submitted."],
    ["A.1.d", "The status of the application."],
    ["A.2.a", "Enter the trading name. If the company incorporated , you must add the following suffixes are LLC, INC, LTD, CORPORATION."],
    ["A.2.b", "Select the business trading type"],
    ["A.2.c", "An outline of what the business is and what it supplies."],
    ["A.2.d", "Select what Bidder provides."],
    ["A.3.a", "Select the name of the Bank that is associated with the Trading Name."],
    ["A.3.b", "Enter the Bank account number."],
    ["A.4.a", " "],
    ["A.4.b", " "],
    ["A.4.c", " "],

    ["A.4.d", "Enter the ZIP code"],
    ["A.4.e", "Select the country"],
    ["A.5.a", "Select Bidder's registered location"],
    ["A.6.a", "Enter contact first name"],
    ["A.6.b", "Enter contact last name"],
    ["A.6.c", "Enter contact number. (eg. 592-600-0000)"],
    ["A.6.d", "Enter contact email"],
    ["A.6.e", "Enter next contact first name"],
    ["A.6.f", "Enter next contact last name"],
    ["A.6.g", "Enter next contact number"],
    ["A.6.h", "Enter next contact email"],
    ["A.7.a", "Enter N/A if no company registration number"],
    ["A.7.b", "Select registration issue date"],
    ["A.7.c", "Check and enter small business registration no."],
    ["A.7.d", "Select date of issue"],
    ["A.7.e", "Enter GRA TIN (9 Digits)"],
    ["A.7.f", "Select the TIN issue date"],
    ["A.7.g", "Enter the VAT number"],
    ["A.7.h", "Select the VAT issue date"],
    ["A.7.i", "Enter the NIS number"],
    ["A.7.j", "Select the NIS issue date"],

    ["A.8.a", "Select the employees/executives count range"],
    ["A.9.a", "Add any comments"],
    ["A.9.b", "check if previously applied"],
    ["OW.1.a", "At least one Director is required if the Company is Incorporated"],
    ////
    //["A.1", "Enter the name of the Bidder as TIN, VAT, NIS, or SBB registered; the same trading name should have been used for all"],
    //["A.2", "Select the business trading type"],
    //["A.3", "Select the Bank that is associated with your trading name"],

    //["A.3.a", "Date Application was submitted. Automatically assigned by system."],
    //["A.3.b", "Unique application id. Automatically generated and assigned when application is submitted."],
    //["A.3.c", "Current application status. CREATE, SUBMIT etc..."],
    //["A.3.d", "The status of the application"],

    //["A.4", "How NPTA contacts the Bidder. NPTA must be immediately informed in writing if changed."],
    //["A.4.a", "Primary Contact Name; First Names LASTNAME, e.g. Robert Nestor MARLEY"],
    //["A.4.a1", "Primary Contact Name; LAST NAME"],
    //["A.4.a2", "Primary Contact Name; FIRST NAME"],
    //["A.4.b", "Primary contact phone number; e.g. +592 227-0094"],
    //["A.4.c", "Primary contact e-mail address. All correspondence between NPTA and Bidder will user this address."],
    //["A.4.d", "Other primary contact phone number; e.g. +592 223-7041"],
    //["A.4.e", "Unique password for Bidder's Online Profile account."],
    //["A.4.f", "Enter the Bidders' email confirmation code."],

    //["A.5", "Alternative contact information if the primary contact is unreachable. NPTA must be informed of any changes"],
    //["A.5.a1", "Next Contact Name; LAST NAME"],
    //["A.5.a2", "Next Contact Name; FIRST NAME"],
    //["A.5.b", "Next contact phone number; e.g. +592 227-0093"],
    //["A.5.c", "Next contact e-mail address. All correspondence between NPTA and Bidder will user this address."],

    //["A.6", "An outline of what the business is and what it supplies."],
    //["A.6.a", "Brief description of the business."],
    //["A.6.b", "Select what Bidder provides."],

    //["A.7", "Choose where the Bidder is located."],

    ["", ""],
  ]
);
@Component({
  selector: 'frm-ctrl-help',
  template: `<div class="messages text-danger tooltip-cursor  tooltip-error {{tooltipInsideCSS}}" placement="{{placement}}" ngbTooltip="{{helpText}}"  ><i class=" fa " [ngClass]="{ 'fa-exclamation text-danger' : ( helpCtrl.invalid && !helpCtrl.pristine ), 'fa-info text-info' : !(( helpCtrl.invalid && !helpCtrl.pristine ))}"></i></div>`
  , styles: [`
.tooltip-cursor {    cursor:help; }
.tooltip-outside{right: 5px;}
}`]

})
export class FormCtrlHelpDirective implements OnInit {

  @Input()
  helpID: string;
  @Input()
  helpCtrl: FormControl;
  @Input()
  helpPlacement: string;
  @Input()
  showIconInside: boolean;

  helpText: string = 'NONE';
  placement: string = 'top';
  tooltipInsideCSS: string = 'tooltip-inside';

  constructor() { }

  ngOnInit() {
    this.helpText = INFO_HELP.get(this.helpID);

    if ((this.helpText === null || this.helpText === '') )
      this.helpText = 'TODO: enter help description';

    if (this.showIconInside === true)
      this.tooltipInsideCSS = '';
    else
      this.tooltipInsideCSS = 'tooltip-outside';



    switch (this.helpPlacement) {
      case 'top':
      case 'left':
      case 'bottom':
      case 'right':
        this.placement = this.helpPlacement;
        break;
      default:
        this.placement = 'top';
    }
  }

}
